import {Component, OnInit, ViewChild, HostBinding, ViewChildren, QueryList, Input} from '@angular/core';
import {ChatService} from "@app/core/services/chat.service";
import { AsideChatUserComponent } from '../aside-chat-user/aside-chat-user.component';

@Component({
  selector: 'aside-chat,[aside-chat]',
  templateUrl: './aside-chat.component.html',
  styles: [`:host{display:block}`]
})
export class AsideChatComponent implements OnInit {

  @ViewChild('chatUsersList') chatUsersList;
  @ViewChild('chatUsersList2') chatUsersList2;

  @ViewChildren(AsideChatUserComponent) boxes !: QueryList<AsideChatUserComponent>;
  @HostBinding('class') classes = 'chat-users top-menu-invisible';
  @HostBinding('class.open') open = false;
  @HostBinding('class.open') open2 = false;

  @Input() type = 'dealers';

  public filter:string = ''
  public users: Array<any> = [];

  public chats: Array<any> = [];

  public rooms:any;

  private user:string;

  constructor(private chatService: ChatService) {}

  ngOnInit() {

    if(this.type=='dealers')
    this.chatService.app.getDealers().subscribe((state)=>{
      this.users = state.map((it:any)=>{
        it.status = it.online?'online':'incognito'
        it.visible = true;
        it.type = 'user';
        return it
      });
    })


    if(this.type=='orders')
    this.chatService.app.getRooms().subscribe((state)=>{
      this.chats = state.map((it:any)=>{
        it.status = (it.status=='Entregada' || it.status=='Cancelada')?'incognito':'online'
        it.visible = true;
        it.code = 'Cliente'
        it.type = 'order';
        return it
      });
    })


    let classe = this;

    this.user = this.chatService.auth.getUser().uid;

    if(this.type=='orders')
    this.rooms = this.chatService.getRooms().onSnapshot(function(snapshot) {
      snapshot.docChanges().forEach(function(change) { 
        
          if (change.type === "added" || change.type === "modified") {
              let data = change.doc.data();
              let boxes = classe.boxes;
              boxes.map(p => {
                const box = p;
                if(p.state.chatId == data.uid && data.open == true){
                  p.openChatBox();
                }
              });

              const n = data.length - data.reads["b-"+classe.user];
              if(n>0)
                $('#badge-'+data.uid).html('<span class="badge bg-color-greenLight pull-right inbox-badge">'+n+'</span>');
              else
                $('#badge-'+data.uid).html("");

          }
          if (change.type === "removed") {
              console.log("Removed room: ", change.doc.data());
          }
      })});
  }

  onFilter(){
    if(this.type=='dealers'){
      this.users.forEach((it)=>{
        if(!this.filter){
          it.visible = true
        } else {
            it.visible = (it.code + '-' + it.alias).toLowerCase().indexOf(this.filter.toLocaleLowerCase()) > -1;
        }
      });
    }else{
      this.chats.forEach((it)=>{
        if(!this.filter){
          it.visible = true
        } else {
          it.visible = (it.title).toLowerCase().indexOf(this.filter.toLocaleLowerCase()) > -1;
        }
      })
    }
    
  }

  openToggle(e) {
    this.open = !this.open;
    $(this.chatUsersList.nativeElement).slideToggle();
    e.preventDefault()
  }
}
